import React, { useEffect, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Marquee from "../components/marquee/Marquee";
import { useSelector } from "react-redux";
import Header from "../components/layaut/Header";
import RightMenu from "./components/RightMenu";
import { ApiService } from "../helpers/services/apiSrevice";
import AlertService from "../helpers/services/alertService";

const SuperDetka = ({ courseData }) => {

    const { user } = useSelector(state => state.user);
    const navigate = useNavigate();
    const title = courseData.title || "";
    const description = "";

     const [isDisabledFields, setIsDisabledFields] = useState(false);

    useEffect(() => {
        if (!user) {
            navigate("/");
        }
    }, [user])

    if (!courseData) { return false };

    if (!courseData || (courseData && !courseData.introduction)) {
        return false
    }

    const downloadZip = (endpoint) => {
        if (!endpoint || isDisabledFields) { return false; }
        setIsDisabledFields(true);
        ApiService.downloadZip(endpoint).then(response => {
            if (response && response.data && typeof response.data === "string") {
                window.open(response.data, "_blank");
            }
        }).catch(error => {
            AlertService.alert("warning", error);
        }).finally(() => {
            setIsDisabledFields(false);
        })
    };

    return <div className="super-detka">
        <HtmlHead title={title} description={description} />

        <RightMenu>
            {/* <div>
                <Link
                    to="/"
                    className="link"
                >
                    главная
                </Link>
            </div> */}
        </RightMenu>

        <Header>
            <div className="w-100 d-flex">
                <div className="d-flex justify-content-center w-100 gap-3">
                    <Link
                        to="/"
                        className={`header-button text-nowrap px-40`}
                    >
                        главная
                    </Link>
                </div>
            </div>
        </Header>
        <Marquee
            content={[courseData.title || '', courseData.title || '', courseData.title || '']}
            blockClassName="main-bg-color"
        />
        <Container fluid className="super-detka p-4 mb-5">
            <Row>
                <Col sm={12}>
                    <div className="text-center">
                        {/* <img className="cursor-pointer download-image" style={{ marginRight: "80px" }} src="/images/download-course.png" onClick={() => window.open(courseData.zipFilePath, "_blank")} /> */}
                        <img className="cursor-pointer download-image" style={{ marginRight: "80px" }} src="/images/download-course.png" onClick={() => downloadZip(courseData.zipFilePath)} />
                    </div>
                    <div className="section section-1">
                        <div dangerouslySetInnerHTML={{ __html: courseData.introduction }}></div>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>


}

export default SuperDetka